import { useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './style.css';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Load from '../../../../../../components/load';
import { departments, jobs } from '../../../../../../components/jobs-departments';

export default function Crew( { media_type, movie_id } ) {

    const [ crew, setCrew ] = useState();

    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';
    const [ loading, setLoading ] = useState(true);

    useEffect(()=>{
        setLoading(true);

        fetch(`https://api.themoviedb.org/3/${media_type}/${movie_id}/${media_type == 'tv' ? 'aggregate_credits' : 'credits'}?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`)
            .then(Response => Response.json())
            .then(data => {

                setCrew(data.crew)
        
                setTimeout(() => {
                    setLoading(false);
                }, 500);
    
            });
    }, [  ])
    
    return (
        <div>
            {loading ?
                <Load align_center={true}/>
            :
                <>
                    {(crew && crew?.length >= 1) &&
                        <div id='div-elenco'>
                            <div className='content-crew'>
                                {crew?.slice(0, 100).map((people, key) =>{
                                    return(
                                        <Link onClick={(e)=>e.preventDefault()} to={`/pessoa/${people?.id}`} className='people-crew' key={key}>
                                            <img loading="lazy" src={people?.profile_path ? (`${image_path}${people?.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={people?.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                            <section className='section-info-crew'>
                                                {people?.original_name && 
                                                    <h3 className='nome-ator'>{people?.original_name}</h3>
                                                }
                                                <span className='nome-personagem'>{departments[people?.department]}</span>
                                                <span className='nome-personagem'>{jobs[people?.job]}</span>
                                            </section>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    )
}